"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFunctionalApiError = void 0;
const httpError_1 = require("../../httpError");
const isFunctionalApiError = (error) => error instanceof httpError_1.HttpError && error.status === 422;
exports.isFunctionalApiError = isFunctionalApiError;
